import { z } from "zod";
/** Telegram Mini App sign-in (apps/api/src/identity/telegram-init-data.ts): the raw initData of Telegram.WebApp. */
export const TelegramInitDataSchema = z.object({ initData: z.string().min(1).max(16_384) });
/** A person's linked Telegram: the fact and the date only; the Telegram id itself is not shown on any screen. */
export const TelegramLinkSchema = z.object({ userId: z.string().uuid(), linkedAt: z.string().datetime({ offset: true }) });
export const TelegramLinksSchema = z.object({ links: z.array(TelegramLinkSchema).max(500) });
export const OwnTelegramLinkSchema = z.object({ link: TelegramLinkSchema.nullable() });
/**
 * The start parameter of a Direct Link Mini App (t.me/<bot>/<app>?startapp=<param>, Telegram's `start_param`):
 * a screen of Vekha by a fixed list of kinds, never a free address (no open redirect). Telegram allows
 * [A-Za-z0-9_-]{1,64}; a kind adds its own strict format. Add a kind here, and the router follows.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/u;
const TELEGRAM_START_ROUTES = [
    { prefix: "report_", valid: (id) => /^[A-Za-z0-9-]{1,57}$/u.test(id), path: (id) => `/report/${id}` },
    { prefix: "dialog_", valid: (id) => UUID.test(id), path: (id) => `/dialogs?deal=${id}` },
];
/** Screens a start parameter names by itself, without an id: `startapp=marketing` — «Маркетинг» in a group's Direct Link. */
const TELEGRAM_START_SCREENS = { marketing: "/analytics/marketing" };
export function telegramStartPath(startParam) {
    if (typeof startParam !== "string" || !/^[A-Za-z0-9_-]{1,64}$/u.test(startParam))
        return null;
    if (Object.hasOwn(TELEGRAM_START_SCREENS, startParam))
        return TELEGRAM_START_SCREENS[startParam];
    for (const route of TELEGRAM_START_ROUTES) {
        if (!startParam.startsWith(route.prefix))
            continue;
        const id = startParam.slice(route.prefix.length);
        return route.valid(id) ? route.path(id) : null;
    }
    return null;
}
/**
 * Short addresses of Vekha (04.11.2026): `/m` — «Маркетинг», the address of the menu button of Arkadiy's bot. The browser goes to the
 * screen's own address before the app reads it (the query and the hash stay: Telegram's launch data is in the hash).
 */
const SHORT_PATHS = { "/m": "/analytics/marketing" };
export function shortPathTarget(pathname) {
    const path = pathname.replace(/\/+$/u, "") || "/";
    return Object.hasOwn(SHORT_PATHS, path) ? SHORT_PATHS[path] : null;
}
//# sourceMappingURL=telegram-login.js.map